// Which shop this panel was opened for.
//
// It comes from the address the frame was opened with, which the SDK builds
// from the public key the brand embedded — never from the host page's own
// address. The same script has to behave identically on Shopify, on
// WooCommerce and on our own themes, and none of them agree on what a domain
// or a path means.
//
// A leaf module on purpose. The store is built the moment the app is imported
// and has to know the shop by then; reaching for it through `utils` would drag
// the service layer, and the store itself, in behind it.

export const getEmbeddedOrgId = () => {
  try {
    const value = new URLSearchParams(window.location.search).get("orgId");
    const trimmed = typeof value === "string" ? value.trim() : "";
    return trimmed ? trimmed : null;
  } catch (e) {
    // No window, or an address the browser will not parse: the app is standing
    // on its own rather than embedded, which the caller treats as "no shop".
    return null;
  }
};
